import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=c7471d88&scoped=true"
import script from "@/views/Users/Student/Dashboard.ts?vue&type=script&lang=ts&external"
export * from "@/views/Users/Student/Dashboard.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Users/Student/dashboard.scss?vue&type=style&index=0&id=c7471d88&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7471d88",
  null
  
)

export default component.exports